import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { multi } from './data';
import {TypeUtils} from "../../utils/type-utils";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-line-charts',
    templateUrl: './ds-line-charts.component.html',
    styleUrls: ['./ds-line-charts.component.scss'],
    standalone: false
})
export class DsLineChartsComponent implements OnChanges {
  @Input() title: string;
  @Input() data: any;
  colorScheme = {
    domain: ['#08DDC1', '#FFDC1B', '#FF5E3A']
  };

  view: any[] = [443, 280];

  constructor() {
    Object.assign(this, { multi });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['data'] && TypeUtils.isDefined(changes['data'].currentValue)) {
      this.data = changes['data'].currentValue;
    }
  }

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
}
